import { combineReducers } from 'redux';
import Authentication from './AuthenticationReducer';
import CustomizerReducer from './customizer/CustomizerReducer';
import Capsule from './CapsuleReducer';

const RootReducers = combineReducers({
  CustomizerReducer,
  Authentication,
  Capsule,
});

export default RootReducers;
